export const MaterialRequisitionPaths = {
  MANAGE_REQUEST_MATERIAL_REQUEST: 'material-request',
  MANAGE_REQUEST_CREATE_MATERIAL_REQUEST: 'create',
  MANAGE_REQUEST_EDIT_MATERIAL_REQUEST: 'edit/:requestId',
  MANAGE_REQUEST_CONFIRM_REQUEST: 'confirm',
};
